import { ButtSizeOptionsType } from './types';

export const BUTT_SIZE_OPTIONS: ButtSizeOptionsType = [
  {
    id: 'small',
    title: 'Small',
  },
  {
    id: 'medium',
    title: 'Medium',
  },
  {
    id: 'large',
    title: 'Large',
  },
  {
    id: 'athletic',
    title: 'Athletic',
  },
];
